"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var Algorithm = (function () {
    function Algorithm() {
    }
    Algorithm.findWeaklyConnectedComponents = function (graph, setConstructor) {
        if (setConstructor === void 0) { setConstructor = Set; }
        var visited = new setConstructor();
        var components = [];
        for (var vertexIterator = graph.getVertices(), vertexResult = vertexIterator.next(); !vertexResult.done; vertexResult = vertexIterator.next()) {
            if (visited.has(vertexResult.value)) {
                continue;
            }
            var component = { edges: [], vertices: [vertexResult.value] };
            var stack = [vertexResult.value];
            visited.add(vertexResult.value);
            while (stack.length > 0) {
                var vertex = stack.pop();
                for (var edgeIterator = graph.getEdgesWithDataTo(vertex), edgeResult = edgeIterator.next(); !edgeResult.done; edgeResult = edgeIterator.next()) {
                    var v = edgeResult.value[0];
                    if (visited.has(v)) {
                        continue;
                    }
                    visited.add(v);
                    component.vertices.push(v);
                    stack.push(v);
                }
                for (var edgeIterator = graph.getEdgesWithDataFrom(vertex), edgeResult = edgeIterator.next(); !edgeResult.done; edgeResult = edgeIterator.next()) {
                    var v = edgeResult.value[0];
                    component.edges.push([vertex, v, edgeResult.value[1]]);
                    if (visited.has(v)) {
                        continue;
                    }
                    visited.add(v);
                    component.vertices.push(v);
                    stack.push(v);
                }
            }
            components.push(component);
        }
        return components;
    };
    Algorithm.getNeighbors = function (graph, vertex) {
        return util_1.createChainedIterator(graph.getPredecessorsOf(vertex), graph.getSuccessorsOf(vertex));
    };
    return Algorithm;
}());
exports.Algorithm = Algorithm;
